import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.show-empty-applicable', () => {
  import('./internal/empty-applicable-block').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.left-shared-menu', () => {
  import('./internal/left-shared-menu').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.note-photos-form', () => {
  import('./internal/note-photos-form').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.ransack-filter', () => {
  import('./internal/ransack-filter').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.notifications', () => {
  import('./internal/restricted-message').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.scout-reports-widget-map', () => {
  import('./internal/scout-reports-map').then(({ default: Component }) => Component());
});
